// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"a005bbe6","70":"2c4e5d1c","75":"dc5d8351","238":"6d8de600","389":"e83d385c","448":"ae2ba8ff","743":"d1aea049"}[chunkId] + ".chunk.js";
};